import React from 'react';
import './analyticsAbsoulteCard.css'

function C2wAnalyticsAbsoulteCard({ className=null, svg = null, arrowSvg=null, heading=null,subpart=null, spanHeading=null }) {
    return (
        <div className={className}>
            <div className='headingHightAnalytics'>
                {heading}
                <span className='C2wAnalyticsSpan'>{spanHeading}&nbsp;</span>
                {subpart}
            </div>
            <div className='analyaticsArrowSvgHld'>
                {arrowSvg}
            </div>
            <div className='C2wAnalytics_svgHolderDiv'>
            {svg}
            </div>
        </div>
    )
}

export default C2wAnalyticsAbsoulteCard
